import { chatCooldownUntilAtomFamily } from '@/atoms/chatCooldownAtoms';
import { isCooldownActive } from '@/components/chat/utils/chatCooldown';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * Per-chat send cooldown. Clears the atom when the wait expires so send,
 * retry, and the queue all observe the same edge.
 */
export const useChatCooldown = (
  stateKey: string
): { active: boolean; until: number | null } => {
  const [until, setUntil] = useAtom(chatCooldownUntilAtomFamily(stateKey));

  useEffect(() => {
    if (until === null) return;

    const remaining = until - Date.now();
    if (remaining <= 0) {
      setUntil(null);
      return;
    }

    const clearTimer = window.setTimeout(() => setUntil(null), remaining);
    return () => window.clearTimeout(clearTimer);
  }, [until, setUntil]);

  const active = isCooldownActive(until);
  return { active, until: active ? until : null };
};
